<template>
    <div class="header">
        <div class="logo">
            <img :src="logo" style="width: 233px; height: 101px">
        </div>
        <div class="right">
            <div class="top rel">
                <!--<div class="search">
                    <img class="icon" :src="search">
                    <div class="input"><input placeholder="输入您想搜索的内容" type="text" name=""></div>
                </div>
                <div class="btn">搜索</div>-->
                <div class="account cl " style="position: absolute; right: 10px;">
                    <img :src="account" class="qr-icon fl">
                    <span class="fl">公众号</span>

                    <div class="qr-codes cl">
                        <img class="qr-code-item fl" :src="wxQrcode1">
                        <img class="qr-code-item fl" :src="wxQrcode2">
                    </div>

                </div>
            </div>
            <div class="bottom">
                <ul>
                    <li v-for="item in navTit" :key="item.idx">
                        <a :href="item.href" :class="{active: item.idx === idx}">{{item.txt}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import Utils from '@/utils/utils'

export default {
    props: [
        'idx'
    ],
    data() {
        const isMczt = /mingchezhantai/.test(location.host)
        // const isMczt = true

        return {
            logo: isMczt ? require('Assets/img/logo.png'): require('Assets/img/logo-qichezhidao.png'),
            search: require('Assets/img/search.png'),
            account: require('Assets/img/account.png'),

            wxQrcode1: require('Assets/img/mczt-wx1.png'),
            wxQrcode2: require('Assets/img/mczt-wx2.jpeg'),

            navTit: [{
                txt: '首页',
                idx: 'index',
                href: Utils.getPageUrl('index')
            }, {
                txt: '图文',
                idx: 'news',
                href: Utils.getPageUrl('news')
            }, {
                txt: '视频',
                idx: 'video',
                href: Utils.getPageUrl('video')
            }],

        }
    },
    mounted() {
        // this.active = this.$route.name
    },
    methods: {
        navTo(item) {
            location.replace('/#/' + item);
        }
    }
}
</script>
<style lang="less" scoped>
.header {
    margin: 32px auto;

    height: 100px;
    display: flex;
    justify-content: space-between;

    .logo {
        cursor: pointer;
        width: 233px;
        height: 100px;
        overflow: hidden;
        background-image: linear-gradient(180deg, #33363B 1%, #20212A 100%);
        border-radius: 8px 8px 0 4px;
    }

    .right {
        width: 963px;

        .top {
            padding-left: 60px;
            height: 52px;
            padding-bottom: 12px;
            display: flex;
            justify-content: flex-start;
            background: #fff;

            .search {
                display: flex;
                justify-content: flex-start;
                background: #FFFFFF;
                border: 2px solid #FF3140;
                width: 640px;
                height: 40px;



                img {
                    width: 12px;
                    height: 12px;
                    margin: 12px 0 0 8px;
                }



                .input {
                    position: relative;
                    height: 40px;

                    input {
                        position: absolute;
                        top: 6px;
                        left: 8px;
                        color: #8B9CB7;
                        font-size: 20px;
                        border: none;
                    }
                }

            }

            .account {
                cursor: pointer;
                vertical-align: middle;
                margin: 10px 0 0 74px;
                font-size: 16px;
                position: relative;

                .qr-icon {
                    width: 14px;
                    height: 14px;
                }

                span {
                    position: relative;
                    top: -3px;
                    left: 8px;
                }

            }

            .account:hover {
                .qr-codes {
                    display: block;
                }
            }

            .btn {
                background: #FF3140;
                cursor: pointer;
                border-top-right-radius: 2px;
                border-bottom-right-radius: 2px;
                width: 82px;
                height: 40px;
                padding-top: 8px;
                font-size: 16px;
                color: #fff;
                text-align: center;
            }
        }

        .bottom {
            padding-left: 60px;
            background: #23252d;
            color: #fff;
            height: 48px;
            padding-top: 12px;
        }

        ul {
            display: flex;
            justify-content: flex-start;
            font-size: 20px;

            li {
                width: 60px;
                margin: 0 40px 0 0;
                cursor: pointer;
                box-sizing: border-box;
            }

            a.active,
            a:hover {
                border-bottom: 4px solid #FF0013;
                padding-bottom: 6px;
            }
        }
    }


    .qr-codes{
        position: absolute;
        z-index: 10;
        right: -20px;
        top: 18px;
        height: 120px;
        width: 240px;
        display: none;

        .qr-code-item{
            width: 120px;
            height: 120px;
        }
    }
}

a {
    color: inherit;
}
</style>
